module.exports = __webpack_public_path__ + "static/estatutos-f291b9eb31f83dc40ffce07150abae75.pdf";